<template>
  <div class="p-0">
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="key"
    >
      <input
        :disabled="question.answered || !linkedUserProfileCategory"
        :checked="item.answer"
        class="form-check-input"
        type="radio"
        :name="question.id"
        :id="`answer-${item.id}`"
        :value="item.id"
        @input="emit($event.target.value)"
      />
      <label :for="`answer-${item.id}`" class="form-check-label">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",

  props: {
    linkedUserProfileCategory: {
      type: Boolean,
      default: false,
    },

    category_id: [String, Number],

    question: Object,
  },

  methods: {
    emit(answer) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
